import { PhoneNumberType } from '@vista-digital/ocapi-types/v1';
import { defaultCustomerDetailsFormData } from '../types/data';
export const mapLoyaltyMemberToFormData = (member) => {
    const { personalDetails, credentials } = member;
    const { name, contactDetails } = personalDetails;
    // TODO: Add fallback to home, then other phone numbers. #286505
    const phone = contactDetails.phoneNumbers.find(phoneNumber => phoneNumber.type === PhoneNumberType.Mobile);
    return {
        givenName: name.givenName || defaultCustomerDetailsFormData.givenName,
        familyName: name.familyName || defaultCustomerDetailsFormData.familyName,
        phoneNumber: (phone === null || phone === void 0 ? void 0 : phone.number) || defaultCustomerDetailsFormData.phoneNumber,
        email: credentials.email || defaultCustomerDetailsFormData.email
    };
};
